import { request, request2 } from "/src/utils/index.js";

export function Search(params) {
  return request.get("sdbs/appointment/list", { params });
}
export function ClubList(params) {
  // return request.get("b2b/business/club/relation/list", { params });
  return request.get("sdcom/club/clinic/list", { params });
}

export function addAppointment(params) {
  return request.post("/sdbs/appointment", params);
}
export function AppointmentDetail(params) {
  return request.get("sdbs/appointment/detail", { params });
}
export function DetelteAppointment(data) {
  return request.delete("/sdbs/appointment", { data });
}

export function GetPeriod(params) {
  return request2.get("sdbs/appointment/period/all", { params });
}
export function CustomerList(params) {
  return request.get("sdbs/customer/list", { params });
}

export function EmployeeList(params) {
  return request2.get("sdcom/employee/list", { params });
}
export function DoctorSetting(params) {
  return request.put("sdapp/schedule/doctor/setting", params);
}
export function CopySchedule(params) {
  return request.post("sdapp/schedule/doctor/section/schedule/copy", params);
}
